import { useCallback, useEffect, useState } from "react";
import { useLocation } from "wouter";

export function useHashTab<T extends string>(defaultTab: T) {
  const [location, setLocation] = useLocation();
  const [activeTab, setActiveTab] = useState<T>(defaultTab);

  // Initialize tab from hash on mount
  useEffect(() => {
    const hash = window.location.hash.slice(1); // Remove # from hash
    if (hash) {
      setActiveTab(hash as T);
    }
  }, []);

  // Update hash when tab changes
  const onTabChange = useCallback(
    (tab?: T | null) => {
      if (!tab) {
        return;
      }
      setActiveTab(tab);
      // Preserve the current path but update the hash
      const [path] = location.split("#");
      setLocation(`${path}#${tab}`, { replace: true });
    },
    [location, setLocation],
  );

  return {
    activeTab,
    onTabChange,
  };
}
